// removed by extract-text-webpack-plugin
module.exports = {"view":"view__1-US2"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AccountCenter/styles.scss
// module id = 2164
// module chunks = 1